import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Use default localStorage
import { createBrowserHistory, createMemoryHistory } from 'history';
import configureStore from '~/configureStore';

const history = typeof window === 'undefined' ? createMemoryHistory() : createBrowserHistory();

// Re-enable persistence now that modal issues are resolved
const DISABLE_PERSISTENCE = false;

/* ------------- Assemble The Reducers ------------- */
import { reducer as appReducer } from './app.js';
import { reducer as developReducer } from './develop.js';
import { reducer as manageReducer } from './manage.js';
import { reducer as vendorReducer } from './vendor.js';
import { reducer as companyReducer } from './company.js';
import { reducer as communityReducer } from './community.js';

const reducers = combineReducers({
    app: appReducer,
    develop: developReducer,
    manage: manageReducer,
    vendor: vendorReducer,
    company: companyReducer,
    community: communityReducer,
});

let store, persistor;

if (DISABLE_PERSISTENCE) {
    // Create store without persistence
    const initialState = {};
    store = configureStore(initialState, reducers, history);

    // Create a dummy persistor with all required methods for PersistGate compatibility
    persistor = {
        persist: () => {},
        getState: () => ({ bootstrapped: true }),
        subscribe: () => () => {}, // Returns unsubscribe function
        flush: () => Promise.resolve(),
        pause: () => {},
        purge: () => Promise.resolve(),
    };
} else {
    // Original persistence setup
    const persistConfig = {
        key: 'root',
        storage,
        blacklist: ['develop', 'manage', 'vendor', 'company', 'community'],
        timeout: 10000,
        debug: false,
    };

    const persistedReducer = persistReducer(persistConfig, reducers);
    const initialState = {};
    store = configureStore(initialState, persistedReducer, history);
    persistor = persistStore(store);
}

export { store, persistor, history };
